import { Coupon } from '@citruscamps/citrus-client'
import React from 'react'
import { useFetchMembershipPackages } from '../../hooks/useFetchMemberPackages'
import { useFetchProducts } from '../../pages/Financials/pages/CouponCreate/hooks/useFetchProducts'
import { formatList, pluralize } from '../../utils/formatters'
import { TruncatedText } from '../TruncatedText/TruncatedText'

interface IProps {
  coupon: Coupon
  programId: string
  show?: 'all' | 'amount' | 'restrictions'
}

/**
 * @deprecated TODO: Product financial foundation is not implemented yet
 * ⚠️ This will be removed in the future when we migrate to products
 **/
export const CouponDescription = ({ coupon, programId, show = 'all' }: IProps) => {
  const { data: products } = useFetchProducts({
    programId,
    enabled: (coupon.applies_to.products || []).length > 0,
    fetchProps: {
      sort: 'created',
      order: 'DESC',
      filter: {
        product_id: coupon.applies_to.products,
      },
    },
  })
  const { data: packages } = useFetchMembershipPackages({
    programId,
    isEnabled: (coupon?.restrictions.membership_packages || []).length > 0,
    fetchProps: {
      sort: 'created',
      order: 'DESC',
      query: {
        id: coupon?.restrictions.membership_packages,
      },
    },
  })

  if (!coupon.amount_off?.major_value && !coupon.percent_off) {
    return null
  }
  const productList = formatList(
    products.map((p) => p.parent.name).filter((c, i, l) => l.indexOf(c) === i),
  )
  const packageList = formatList(
    packages.map((p) => p.name).filter((c, i, l) => l.indexOf(c) === i),
  )
  const restrictions = [
    coupon.restrictions.limit_customer && 'One use per customer',
    coupon.restrictions.max_redemptions &&
      `Limited to ${coupon.restrictions.max_redemptions} total redemptions`,
    coupon.restrictions.membership_packages &&
      coupon.restrictions.membership_packages?.length > 0 &&
      `Customers with ${packageList || 'specific memberships'}`,
    coupon.restrictions.minimum_items &&
      `Minimum ${coupon.restrictions.minimum_items} item${pluralize(
        coupon.restrictions.minimum_items,
      )} on order`,
    coupon.restrictions.minimum_amount?.major_value &&
      `Minimum ${coupon.restrictions.minimum_amount?.display} on order`,
    coupon.apply_automatically && 'Applies automatically',
  ]
    .filter(Boolean)
    .join(' • ')

  const amount = `${
    coupon.amount_off?.major_value ? coupon.amount_off.display : coupon.percent_off + '%'
  } ${
    !!coupon.applies_to.products && coupon.applies_to.products?.length > 0
      ? `off of ${productList}`
      : !!coupon.applies_to.product_types && coupon.applies_to.product_types?.length > 0
      ? `off of ${formatList(
          coupon.applies_to.product_types.map((t) =>
            t === 'session_package' ? 'session credits' : t + 's',
          ),
        )}`
      : 'off of all products'
  }`

  if (show === 'amount') {
    return <TruncatedText>{amount}</TruncatedText>
  }

  if (show === 'restrictions') {
    return <TruncatedText>{restrictions || 'No restrictions'}</TruncatedText>
  }

  return (
    <>
      <TruncatedText>{amount}</TruncatedText>
      <TruncatedText>{restrictions || 'No restrictions'}</TruncatedText>
    </>
  )
}
